<template>
    <div id="orderItemEdit" class="production-plan-edit">
        <div style="margin-left:20px" class="orderinfo">
            <el-row>
                <el-row class="operateBtn-wrap" style="margin-top:0px;">
                    <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderItemView">返回</el-button>
                </el-row>
            </el-row>
            
            <el-row style="margin-top: 10px;">
                <span class="label">订单号：</span>
                <span class="value" :style="W?{width:'210px'}:{width:'180px'}">{{selectedSplit.orderCode?selectedSplit.orderCode:selectedSplit.orderCode}}</span>

                <span class="label">下单日期：</span>
                <span class="value" :style="W?{width:'210px'}:{width:'180px'}">{{selectedSplit.orderTime}}</span>

                <span class="label" >交付日期：</span>
                <span class="value" >{{selectedSplit.deliverTime}}</span>
                
                <span class="label">订单状态：</span>
                <span class="value">{{selectedSplit.parseStateText}}</span>
            </el-row>

            <el-row style="margin-top: 10px;">
                <span class="label">物料编码：</span>
                <span class="value" :style="W?{width:'210px'}:{width:'180px'}">{{selectedSplit.orderRowMaterialCode}}</span>

                <span class="label">物料名称：</span>
                <span class="value" :style="W?{width:'210px'}:{width:'180px'}">{{selectedSplit.orderRowMaterialName}}</span>

                <span class="label" >物料规格：</span>
                <span class="value" >{{selectedSplit.orderRowSpecification}}</span>
                
                <span class="label">数量：</span>
                <span class="value">{{selectedSplit.orderRowCount}} </span>
            </el-row>

            <el-row style="margin-top: 10px;">
                <div style="width:78%;display:inline-block">
                    <span class="label">订单备注：</span>
                    <span class="value" style="width:300px">{{selectedSplit.remark}}</span>
                </div>
                <div style="text-align:right;display:inline-block;width:20%;position: relative;top: -10px;">
                    <el-button v-if="permission.btn_productionTask_executionGroup"  type="primary" @click="openImportAllPlanDialog"  size="small">导入派工</el-button>
                    <el-button v-if="permission.btn_productionPlan_printPlan"  type="primary" @click="openPrintDialog"  size="small">打印流转卡</el-button>
                </div>
            </el-row>
        </div>
        
        <div v-for="(item,index) in orderItemList" :key='item.splitId'>
            <OrderItemBaseEdit :baseData.sync='orderItemList[index]' :key='item.splitId'  :allDeviceListProp='allDeviceListProp' :allWorkerSelectProp='allWorkerSelectProp' :allWorkershopListProp='allWorkershopListProp'></OrderItemBaseEdit>
        </div>

        <!-- 打印流转卡开始 -->
        <el-dialog title="打印流转卡" center :visible.sync="showPrintDialog" width="60%"  :close-on-click-modal="false">
            <el-table  :data="printData" stripe  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column label="订单号" min-width="100" prop="productionBatchCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="工单号" min-width="100" prop="orderCode" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料名称" min-width="100" prop="materialName" show-overflow-tooltip></el-table-column>
                <el-table-column label="物料编码" prop="materialCode" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column label="规格" min-width="50" prop="specification"></el-table-column>
                <el-table-column label="数量" prop="amount" min-width="70"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitPrintDialog">打 印</el-button>
                <el-button @click="cancelPrintDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 打印流转卡结束 -->
        <ImportAllPlan :orderCode='selectedSplit.orderCode' :orderRowMaterialName = 'selectedSplit.orderRowMaterialName' :isShow.sync='isShowDialog' ></ImportAllPlan>
    </div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils'
import pinyinMatch from 'pinyin-match'
import OrderItemBaseEdit from './OrderItemBaseEdit.vue'
import ImportAllPlan from './ImportAllPlan.vue'
export default {
    name: 'OrderItemEdit',
    props: {
        selectedSplit: Object,
        allDeviceList: Array, 
        allWorkerSelect : Array,
        allWorkershopList: Array,
    },
    components:{
        OrderItemBaseEdit,
        ImportAllPlan
    },
    data() {
        return {
            isShowDialog:false,
            orderItemList:[],
            showPrintDialog:false,
            printData:[],
            loading: false,
            W: false,
            selectData:[],
            allDeviceListProp:[],
            allWorkerSelectProp:[],
            allWorkershopListProp:[],
            fristEdit: true,  //默认第一次编排任务
            permission: JSON.parse(localStorage.getItem("permission")),
        }
    },
    
    beforeMount: async function () {
        this.allDeviceListProp = commonUtils.cloneObj(this.allDeviceList) 
        this.allWorkerSelectProp = commonUtils.cloneObj(this.allWorkerSelect)
        this.allWorkershopListProp = commonUtils.cloneObj(this.allWorkershopList)
        this.loadOrderItemPlan()
    },

    //完成挂载
    mounted: function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        
    },

    //更新dom时触发

    computed: {
        
    },

    methods: {
        loadOrderItemPlan(){
            this.$RequestUtil.post({
                url: '/api/productionPlan/listBatchPreProductionPlan',
                type: 'sync',
                params: {
                    businessOrderItemId:this.selectedSplit.businessOrderItemId,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.orderItemList = res.data
                        this.orderItemList.forEach(item=>{
                            item.deliverTime = this.selectedSplit.deliverTime
                            item.orderTime = this.selectedSplit.orderTime
                        })
                        this.printData = this.orderItemList.map(item=>{
                            return {
                                splitId:item.splitId,
                                specification:item.specification,
                                materialName:item.materialName,
                                materialCode:item.materialCode,
                                amount:item.needAmount,
                                productionBatchCode:item.childProductionBatchCode?item.childProductionBatchCode:item.productionBatchCode,
                                orderCode:item.productionOrderCode?item.productionOrderCode:item.orderCode,
                                
                            }
                        })
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        },

        handleSelectionChange(ev){
            this.selectData = ev
        },

        async submitPrintDialog(){
            if(this.selectData.length==0){
                this.$message.warning('请选勾选需要打印数据')
                return
            }
            let params = {
                splitIdList:this.selectData.map(item=>item.splitId)
            }
            let {data,code,msg,message} = await this.$RequestUtil.postAsync({ url: '/api/productionPlan/batchPrintPlanGM', type: 'sync', params, })
            if(code!=0){
                this.$message.error(msg||message)
                return
            }
            localStorage.setItem('printAllOrderData', JSON.stringify(data))
            localStorage.setItem('modelType', 4)         
            this.showPrintDialog = false          
            let routeUrl = this.$router.resolve({ path: "/printAllOrder" });
            window.open(routeUrl.href, '_blank');
           
        },

        cancelPrintDialog(){
            this.showPrintDialog = false
        },

        openPrintDialog(){
            this.showPrintDialog = true
        },
        openImportAllPlanDialog(){
            this.isShowDialog = true
        },
        backToOrderItemView(){
            this.$parent.showPage = 1
            this.$parent.loadBusinessOrderPart()
        },

        //匹配导入派工
        async matchingImportData(data){
            //1.过滤当前页面需要（生产中之前的状态）导入派工的工单
            let needImportTask = []
            let count = 0
            for(let index=0;index< this.orderItemList.length;index++){
                let item = this.orderItemList[index]
                if(item.splitStatus<3){
                    let json = {
                        index,
                        splitId:item.splitId,
                        specification:item.specification,
                        materialName:item.materialName,
                        materialCode:item.materialCode,
                        materialId:item.materialId,
                        splitStatus:item.splitStatus,
                        tecId:item.tecId,
                        productionBatchCode:item.childProductionBatchCode?item.childProductionBatchCode:item.productionBatchCode,

                    }
                    //2.状态为已派工的工单确认是否需要覆盖之前编排的数据
                    if(item.splitStatus==2){
                        let res  = await this.$confirm(`${json.productionBatchCode}已派工，是否覆盖?`, '提示', {distinguishCancelAndClose: false,cancelButtonClass: "btn-custom-cancel",
                                confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).catch(() => {})
                        if( res== 'confirm'){
                            needImportTask.push(json)
                        }
                    }else{
                        needImportTask.push(json)
                    }
                }
            }
                
            //3.最终需要导入派工的工单中查找匹配物料名称相同并且工艺相同的的历史工单
            
            // data = data.filter(d=>d.splitStatus>2)
            needImportTask.forEach((item,index)=>{
                let matchingArr =  data.filter(d=>d.materialName==item.materialName)
                if(matchingArr.length==0&&item.productionBatchCode){
                    // this.$message.warning(`${item.productionBatchCode}物料名称不匹配，无法导入派工`)
                    this.$message({
                        type:'warning',
                        message:`${item.productionBatchCode}物料名称不匹配，无法导入派工`,
                        duration:3000+index*300,
                        offset:10+index*30,
                        showClose:true
                    })
                }
                item.matchingArr = matchingArr
            })
            //4.获取需要需要导入历史工单号集合
            // let historyTaskList = needImportTask.map(item=>{
            // return item.matchingArr[0].productionBatchCode
            // })

            //5.根据工单id集合查询工序数据
            let splitIds = needImportTask.map(item=>[item.splitId,item.tecId])
            let importDispatchingIds = data.map(item=>item.orderSplitId)
            if(splitIds.length==0){
                this.$message.warning('未找到需要导入派工的工单')
                this.isShowDialog = false
                return
            }
            this.$RequestUtil.post({
                url: '/api/order/batchImportDispatching',
                type: 'sync',
                params: {
                    splitIds,
                    importDispatchingIds
                },
                success: (res) => {
                    if (res.code == 0) {
                        res.data.forEach((item,index)=>{
                            if(item.resultCode==-1&&item.wrongMessage){
                                this.$message({
                                    type:'error',
                                    message:item.wrongMessage,
                                    duration:3000+index*300,
                                    offset:80+index*40,
                                    showClose:true
                                })
                            }
                        })
                        let hasErr = res.data.some(item=>item.resultCode==-1)
                        if(!hasErr){
                            this.$message({
                                type:'success',
                                message:'导入成功',
                            })
                        }
                        this.orderItemList.forEach(item=>{
                            let importPlan = res.data.find(d=>d.splitId==item.splitId)
                            if(importPlan){
                                item.procedureList = importPlan.procedureList
                            }
                        })
                        this.isShowDialog = false
                        
                    } else {
                        this.$message.error(res.message);
                    }
                },
            })
                
            
        },

        async loadHistoryTaskByTaskIdList(taskIdList){
            let data = await this.$RequestUtil.getAsync({url: '/api/productionTask/executionGroup',type: 'sync',params: {taskIdList},})
        }
    },
    watch: {
       
    },
}
</script >

<style scoped>
    .operateBtn-wrap {
        margin-top: 20px;
    }
    .label {
        display: inline-block;

        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: #606266;
    }
    .value {
        display: inline-block;
        width: 200px;
        line-height: 32px;
        font-size: 14px;
        color: #606266;
        vertical-align: top;
    }

    .file-icon-container {
        width: 36px;
        height: 45px;
        margin-top: -17px;
        background-size: cover;
        position: relative;
        cursor: pointer;
    }


    @media screen and (max-width: 1366px) {
        .orderinfo .value {
            width: 160px;
        }
        .file-icon-container {
            width: 27px;
            height: 36px;
            margin-top: -10px;
        }
    }
    @media screen and (max-width: 1280px) {
        .value {
            width: 166px;
        }
    }
</style>


<style>
    .value .el-input__inner {
        height: 28px;
        line-height: 28px;
    }
    .select_width {
        width: 139px;
    }
    .select_width1 {
        width: 250px;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/SalesOrder/OrderItemEdit.vue